import { useEffect, useSyncExternalStore } from 'react'

/**
 * How many "No BNB" panels are on the page right now. The fixed profile bar (views/Social/AutoJoin) stays hidden while one is shown, so a
 * banner never covers the guide's text or the button under it (manager review of Stage r166, 2026-10-07).
 */
let count = 0
const listeners = new Set<() => void>()
const emit = () => listeners.forEach((l) => l())

/** Call from a panel: counts it while `on` and mounted. */
export function useNoBnbPresence(on: boolean) {
  useEffect(() => {
    if (!on) return undefined
    count += 1
    emit()
    return () => {
      count -= 1
      emit()
    }
  }, [on])
}

const subscribe = (l: () => void) => {
  listeners.add(l)
  return () => {
    listeners.delete(l)
  }
}
/** True while at least one panel is shown. */
export const useNoBnbShown = () => useSyncExternalStore(subscribe, () => count > 0, () => false)
